// account-ui catalog — locale sv (register: du, informal).
import en from './en';

const sv: typeof en = {
  common: {
    loading: 'Laddar…',
  },
  account: {
    brand: 'lumi HR',
    home: {
      title: 'Ditt lumi HR-konto',
      intro:
        'Den här sidan tillhör dig, inte en arbetsyta. Den är kvar även när en arbetsyta som du tillhör är låst eller avslutad.',
      rightsTitle: 'Det här kan du göra här',
      rights: {
        takeout: 'Ladda ner en kopia av dina uppgifter så snart den är förberedd åt dig.',
        erasure:
          'Begära att en arbetsyta och dess uppgifter raderas, eller dra tillbaka en begäran som du själv har lämnat in.',
        invoices: 'Se och ladda ner fakturorna för en arbetsyta som du administrerar.',
        export: 'Exportera en arbetsyta som du äger – alla dess uppgifter i ett krypterat arkiv.',
      },
      signInHint:
        'Allt det här kräver att du loggar in först. En länk som vi mejlar dig pekar bara hit — den loggar aldrig in dig.',
      workspaceHint:
        'Allt annat – ditt dagliga arbete och dina inställningar – finns kvar i din arbetsyta.',
    },
    signIn: {
      title: 'Logga in',
      intro:
        'Använd din e-postadress i lumi HR och ditt lösenord. Du behöver inte ange någon arbetsyta – vi visar dig dem du tillhör.',
      email: 'E-postadress',
      password: 'Lösenord',
      submit: 'Logga in',
      failed: 'Vi kunde inte logga in dig med den e-postadressen och det lösenordet.',
      passkey: 'Logga in med en nyckel',
      passkeyHint:
        'Ingen e-postadress? Ett konto som skapats med ett mobilnummer loggar in med sin nyckel.',
      passkeyFailed: 'Vi kunde inte logga in dig med den nyckeln.',
      operatorSecondFactor: 'Det här är ett systemadministratörskonto som kräver en andra faktor. Logga in här med en nyckel; med lösenord och autentiseringskod loggar du in i lumi-konsolen.',
    },
    session: {
      signedInAs: 'Inloggad som {email}.',
      signOut: 'Logga ut',
    },
    workspaces: {
      title: 'Dina arbetsytor',
      intro:
        'De arbetsytor du tillhör. En låst arbetsyta finns kvar i listan – det är just därför den här sidan finns.',
      emptyTitle: 'Inga arbetsytor',
      emptyBody:
        'Det här kontot tillhör ingen arbetsyta. Om du väntade dig en här, fråga personen som bjöd in dig.',
      loadFailed: 'Vi kunde inte hämta dina arbetsytor.',
      ssoRequired:
        'Den här arbetsytan kräver företagets enkla inloggning (SSO). Logga in via arbetsytan själv för att använda de här verktygen – ett lösenord öppnar den inte här.',
      state: {
        active: 'Aktiv',
        suspended: 'Låst',
        provisioning: 'Under uppsättning',
        erased: 'Raderad',
        unavailable: 'Otillgänglig',
      },
      hint: {
        active: 'Den här arbetsytan fungerar som vanligt.',
        suspended: 'Den här arbetsytan är låst. Du kan ändå utöva dina rättigheter här.',
        provisioning: 'Den här arbetsytan håller fortfarande på att sättas upp.',
        erased:
          'Den här arbetsytan och dess uppgifter har raderats. Bara fakturorna finns kvar, eftersom vi är skyldiga att spara dem.',
        unavailable: 'Den här arbetsytan går inte att nå just nu.',
      },
    },
    invoices: {
      open: 'Visa fakturor',
      hide: 'Dölj fakturor',
      empty: 'Det finns inga fakturor för den här arbetsytan.',
      loadFailed: 'Vi kunde inte hämta fakturorna för den här arbetsytan.',
      download: 'Ladda ner PDF',
      documentMissing: 'Den här fakturan har inget dokument att ladda ner.',
      documentUnavailable:
        'Fakturadokumentet går inte att hämta just nu. Det finns kvar – försök igen om en stund.',
      downloadFailed: 'Vi kunde inte ladda ner den fakturan.',
    },
    takeout: {
      title: 'Kopian av dina uppgifter',
      what:
        'Det här är en kopia av de personuppgifter om dig som den här arbetsytan lagrar, tillsammans med en förklaring av vad de används till.',
      availableUntil:
        'Du kan ladda ner den till och med {date}. Därefter raderas den automatiskt, så spara den innan dess om du vill behålla den.',
      download: 'Ladda ner mina uppgifter',
      none: 'Det finns ingen kopia av dina uppgifter som väntar på dig här.',
      expired:
        'Kopian som togs fram åt dig gick att ladda ner till och med {date}. Den har sedan raderats, precis som vi sa.',
      howToAsk:
        'Du kan när som helst be om en kopia: kontakta arbetsytan som har dina uppgifter. Så snart den är klar mejlar vi dig, och du laddar ner den på den här sidan.',
      loadFailed: 'Vi kunde inte kontrollera om en kopia av dina uppgifter väntar på dig.',
      downloadUnavailable:
        'Din kopia går inte att hämta just nu. Den finns kvar – försök igen om en liten stund.',
      downloadFailed: 'Vi kunde inte ladda ner kopian av dina uppgifter.',
    },
    export: {
      title: 'Exportera den här arbetsytan',
      intro:
        'Ladda ner allt i den här arbetsytan som ett enda krypterat arkiv. Det fungerar även när arbetsytan är låst – det är just därför den här sidan finns.',
      contents:
        'Arkivet innehåller varje persons uppgifter, varje fil som laddats upp till arbetsytan och dess kopplingar till andra tjänster. Behandla det som arbetsytan själv: förvara det säkert och lämna det inte till någon som inte får se allt. Arkivet innehåller också, för Personal, Rekrytering och Tid, ett HR Open Standards-dokument (HR-JSON) — det delade formatet om du byter leverantör.',
      passphraseWarning:
        'Du väljer lösenfrasen och vi sparar den aldrig. Utan den går arkivet inte att öppna igen – varken av dig eller av oss.',
      passphraseLabel: 'Lösenfras för arkivet',
      passphraseHint: 'Minst {min} tecken.',
      confirmLabel: 'Upprepa lösenfrasen',
      submit: 'Starta exporten',
      started:
        'Exporten har startat. Det tar en stund att förbereda den – kom tillbaka till den här sidan och uppdatera listan.',
      errorTooShort: 'Välj en lösenfras med minst {min} tecken.',
      errorMismatch: 'De två lösenfraserna är inte lika. Kontrollera dem och försök igen.',
      errorCannotStart:
        'Exporten kan inte starta just nu: antingen pågår redan en export av den här arbetsytan, eller så håller arbetsytan på att stängas.',
      errorTooMany:
        'Den här arbetsytan har startat så många exporter som den får i dag. Försök igen i morgon.',
      errorGeneric:
        'Vi kunde inte starta exporten. Ingenting ändrades – försök igen om en liten stund.',
      listTitle: 'Exporter av den här arbetsytan',
      refresh: 'Uppdatera',
      loadFailed: 'Vi kunde inte hämta exporterna för den här arbetsytan.',
      empty: 'Ingen export av den här arbetsytan har gjorts ännu.',
      startedAt: 'Startad {date}',
      availableUntil: 'Kan laddas ner till och med {date}',
      download: 'Ladda ner arkivet',
      downloadGone: 'Det här arkivet finns inte längre. Starta en ny export för att få ett nytt.',
      downloadUnavailable:
        'Arkivet går inte att hämta just nu. Det finns kvar – försök igen om en liten stund.',
      downloadFailed: 'Vi kunde inte ladda ner arkivet.',
      status: {
        requested: 'I kö',
        exporting: 'Förbereds',
        exported: 'Klar att ladda ner',
        failed: 'Misslyckades',
        expired: 'Raderad',
        unknown: 'Okänd status',
      },
    },
    erasure: {
      file: 'Begär radering av den här arbetsytan',
      loadFailed: 'Vi kunde inte kontrollera om radering har begärts för den här arbetsytan.',
      confirmTitle: 'Begära radering av den här arbetsytan?',
      confirmWhatGoes:
        'Allt i ”{workspace}” raderas då permanent: varje personalakt, varje ansökan, varje dokument, varje tidsregistrering och varje inställning, för alla som arbetar i den. Efteråt går ingenting att få tillbaka.',
      confirmProcess:
        'Du lämnar in en begäran, ingenting raderas ännu. Vi granskar den, och när den godkänts börjar en väntetid. Du kan dra tillbaka begäran när som helst fram till att raderingen faktiskt startar.',
      invoicesKept: 'Fakturorna blir kvar, eftersom lagen kräver att vi sparar dem.',
      reason: 'Orsak (valfritt)',
      keep: 'Nej, behåll den här arbetsytan',
      confirmSubmit: 'Ja, begär radering',
      pendingReview: 'Radering har begärts för den här arbetsytan. Vi granskar begäran.',
      pendingUntil: 'Radering har begärts för den här arbetsytan. Den raderas efter {date}.',
      paymentsPending:
        'Den här arbetsytan är inplanerad för radering eftersom kontot inte har betalats.',
      paymentsPendingUntil:
        'Den här arbetsytan är inplanerad för radering eftersom kontot inte har betalats. Den raderas efter {date}.',
      paymentsSettle:
        'Om den obetalda fakturan betalas stoppas raderingen. Du kan också begära raderingen själv – då genomförs den oavsett betalningen.',
      paymentsCannotWithdraw:
        'Den här raderingen planerades för att kontot inte har betalats och går därför inte att dra tillbaka här. Betala den obetalda fakturan för att stoppa den.',
      confirmTakeover:
        'Den här arbetsytan är redan inplanerad för radering eftersom kontot inte har betalats. Din begäran tar över den raderingen: att betala fakturan stoppar den då inte längre.',
      withdraw: 'Dra tillbaka begäran om radering',
      withdrawTitle: 'Dra tillbaka begäran om radering?',
      withdrawBody:
        'Den här arbetsytan och alla data behålls. Du kan begära radering igen när som helst.',
      confirmType: 'Skriv arbetsytans namn ({name}) för att bekräfta',
      confirmMismatch:
        'Namnet du skrev stämmer inte med den här arbetsytan. Kontrollera det och försök igen.',
      tooLate: 'Raderingen har börjat och går inte längre att dra tillbaka.',
      conflict: 'Den här arbetsytan håller redan på att raderas, så ingenting ändrades.',
      nothingOpen: 'Det finns ingen begäran om radering att dra tillbaka för den här arbetsytan.',
      filed: 'Din begäran om radering har skickats. Vi granskar den.',
      withdrawn: 'Begäran om radering har dragits tillbaka. Den här arbetsytan behålls.',
    },
    closure: {
      title: 'Stänga ditt lumi-konto',
      intro:
        'Det här gäller själva ditt lumi-konto – din inloggning – och inte någon av arbetsytorna ovan.',
      open: 'Stäng mitt konto',
      confirmTitle: 'Stänga ditt lumi-konto?',
      whatGoes:
        'Din inloggning försvinner: den här e-postadressen och det här lösenordet slutar fungera, en kopplad företagsinloggning kopplas bort och du lämnar varje arbetsyta du tillhör. Det du själv har gjort hos lumi försvinner också: vi raderar dina samtal med assistenten, de aviseringar vi har skickat till dig och dina inställningar för dem, och vi tar bort ditt namn och det du har skrivit ur de supportärenden och meddelanden du har skickat till oss.',
      whatStays:
        'Dina uppgifter hos varje arbetsgivare stannar hos den arbetsgivaren. lumi driver systemen, men varje företag ansvarar självt för sina personal- och ansökningsuppgifter, och att stänga kontot här raderar dem inte. Är en arbetsyta föremål för en rättsprocess eller en myndighetsutredning måste vi spara det som hör till den: dina ärenden, meddelanden och samtal från den arbetsytan ligger då kvar tills det är avslutat.',
      howToErase:
        'Vill du att uppgifterna hos en arbetsgivare raderas ber du det företaget direkt. Företaget svarar självt på en sådan begäran, och en del av uppgifterna måste det enligt lag spara ytterligare en tid.',
      noUndo:
        'Stängningen går inte att ångra, och ingenting hålls öppet åt dig. Du kan när som helst registrera dig igen med samma e-postadress – då skapas ett nytt, tomt konto.',
      confirmType: 'Skriv din e-postadress ({email}) för att bekräfta',
      confirmMismatch:
        'Det är inte e-postadressen för det här kontot. Kontrollera den och försök igen.',
      keep: 'Nej, behåll mitt konto',
      confirmSubmit: 'Ja, stäng mitt konto',
      doneTitle: 'Ditt konto är stängt',
      doneBody:
        'Du är utloggad, och den här e-postadressen och det här lösenordet loggar inte längre in någonstans i lumi. Dina samtal med assistenten och de aviseringar vi har skickat till dig är raderade, och de supportärenden och meddelanden du har skickat till oss innehåller inte längre ditt namn eller det du har skrivit.',
      doneStays:
        'Dina uppgifter hos varje arbetsgivare stannar hos den arbetsgivaren och hanteras fortfarande av dem. Vill du att de raderas ber du varje företag direkt. Och är en arbetsyta föremål för en rättsprocess eller en myndighetsutredning ligger det som hör till den kvar hos oss tills det är avslutat.',
      doneMailed: 'Vi har skickat en bekräftelse till din e-postadress.',
      doneNotMailed: 'Vi kunde inte skicka bekräftelsen via e-post. Ditt konto är stängt ändå.',
      blockedTitle: 'De här arbetsytorna behöver fortfarande en ägare',
      blockedBody:
        'Du är ensam ägare till arbetsytorna nedan, så vi kan inte stänga ditt konto än. En arbetsyta utan ägare kan bara vi öppna igen, och alla som arbetar i den skulle bli utestängda från sina egna uppgifter.',
      blockedTransfer:
        'Lämna över ”{name}”: öppna den arbetsytan och överför ägarskapet där till en annan medlem.',
      blockedErasure: 'Eller begär radering av ”{name}” i listan över dina arbetsytor ovan.',
      blockedReturn:
        'Det här försöket sparas inte. När ingen arbetsyta längre behöver dig som ägare kommer du tillbaka hit och stänger kontot då.',
      unavailable:
        'Det går inte att stänga konton just nu. Ingenting ändrades – försök igen om en stund.',
      alreadyClosed: 'Det här kontot är redan stängt.',
      failed: 'Det gick inte. Ditt konto stängdes inte – försök igen om en stund.',
      confirmTypePhone: 'Skriv hela ditt mobilnummer ({phone}) för att bekräfta',
      confirmMismatchPhone:
        'Det är inte mobilnumret för det här kontot. Kontrollera det och försök igen.',
      whatGoesPhone:
        'Din inloggning försvinner: dina nycklar och det här mobilnumret slutar fungera, en kopplad företagsinloggning kopplas bort och du lämnar varje arbetsyta du tillhör. Det du själv har gjort hos lumi försvinner också: vi raderar dina samtal med assistenten, de aviseringar vi har skickat till dig och dina inställningar för dem, och vi tar bort ditt namn och det du har skrivit ur de supportärenden och meddelanden du har skickat till oss.',
      noUndoPhone:
        'Stängningen går inte att ångra, och ingenting hålls öppet åt dig. En arbetsyta kan bjuda in dig igen med samma nummer – då skapas ett nytt, tomt konto.',
      doneBodyPhone:
        'Du är utloggad, och dina nycklar och det här mobilnumret loggar inte längre in någonstans i lumi. Dina samtal med assistenten och de aviseringar vi har skickat till dig är raderade, och de supportärenden och meddelanden du har skickat till oss innehåller inte längre ditt namn eller det du har skrivit.',
      doneScreenOnly: 'Den här sidan är din bekräftelse – vi skickar ingen via sms.',
    },
  },
};

export default sv;
